import { render, staticRenderFns } from "./ApplicationSearch.vue?vue&type=template&id=0b94f002&scoped=true"
import script from "./ApplicationSearch.vue?vue&type=script&lang=ts"
export * from "./ApplicationSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b94f002",
  null
  
)

export default component.exports